import React, { useState } from "react";
import { formatMoney } from "@shopify/theme-currency";
import * as cart from "@shopify/theme-cart";

const MiniCartItem = ({
  item,
  handleRefreshCart,
  handleCartLoaded,
  miniCartData,
  items,
}) => {
  const handleUpdateCount = (action) => {
    let isBundle = item.properties["_is_bundle_item"];
    let bundleCount = parseInt(item.properties["_products_in_bundle"]);
    let bundleId = item.properties["_click_time"];
    let quantity = item.quantity;
    let processedItems = 0,
      bundleItemsInCart;
    cart.getState().then((data) => {
      bundleItemsInCart = data.items.filter((item) => {
        if (item.properties["_click_time"] == bundleId) {
          return item;
        }
      }).length;
      action === "plus" ? (quantity += 1) : (quantity -= 1);
      if (quantity > 0) {
        if (isBundle && bundleItemsInCart == bundleCount) {
          data.items.forEach((cartItem) => {
            if (cartItem.properties["_click_time"] == bundleId) {
              cart.updateItem(cartItem.key, { quantity }).then((state) => {
                processedItems++;
                if (bundleCount == processedItems) {
                  handleRefreshCart(item.key, state);
                }
              });
            }
          });
        } else {
          cart.updateItem(item.key, { quantity }).then((state) => {
            handleRefreshCart(item.key, state);
          });
        }
        action === "plus" ? (headerCartCount += 1) : (headerCartCount -= 1);
        headerCart.innerHTML = headerCartCount;
      } else if (quantity == 0) {
        if (isBundle && bundleItemsInCart == bundleCount) {
          data.items.forEach((cartItem) => {
            if (cartItem.properties["_click_time"] == bundleId) {
              cart.removeItem(cartItem.key).then((state) => {
                processedItems++;
                if (bundleCount == processedItems) {
                  handleRefreshCart(item.key, state);
                }
              });
            }
          });
        } else {
          cart.removeItem(item.key).then((state) => {
            handleRefreshCart(item.key, state);
            headerCart.innerHTML = headerCartCount - 1;
          });
        }
      }
    });
  };

  const handleRemoveItem = () => {
    let quantity = item.quantity;
    cart.removeItem(item.key).then((state) => {
      handleRefreshCart(item.key, state);
    });
  };

  let discounted_price = false;
  let diff_discounted = 0;
  let discounted_class = "";
  let comparePrice = 0;

  if (item.discounted_price != item.original_price) {
    discounted_price = true;
    discounted_class = "with-discount";
    if (
      item.properties["_product_compare"] &&
      item.properties["_product_compare"] != "null"
    ) {
      diff_discounted =
        (parseInt(item.properties["_product_compare"]) -
          parseInt(item.properties["_product_price"])) *
          item.quantity +
        item.total_discount;
      comparePrice =
        parseInt(item.properties["_product_compare"]) * item.quantity;
    } else {
      diff_discounted = item.original_line_price - item.line_price;
      comparePrice = item.original_line_price;
    }
  }

  if (
    !discounted_price &&
    item.properties &&
    item.properties["_product_compare"] &&
    item.properties["_product_compare"] != item.properties["_product_price"]
  ) {
    discounted_price = true;
    discounted_class = "with-discount";
    diff_discounted =
      (parseInt(item.properties["_product_compare"]) -
        parseInt(item.properties["_product_price"])) *
      item.quantity;
    comparePrice =
      parseInt(item.properties["_product_compare"]) * item.quantity;
  }

  const product_url = `/products/${item.handle}`;
  let hide_qty_class = "";
  let bundleId = item.properties["_click_time"];
  let bundleItems = items.filter((itemSingle) => {
    if (bundleId && itemSingle.properties["_click_time"] == bundleId) {
      return item;
    }
  }).length;
  let bundleCount = parseInt(item.properties["_products_in_bundle"]);
  if (
    (item.properties["_is_bundle_item"] && bundleCount == bundleItems) ||
    item.handle == "rise-ai-giftcard"
  ) {
    hide_qty_class = "hide-quantity";
  }

  return (
    <div className="mini-cart__item">
      <div className="mini-cart__item-image">
        <a href={product_url}>
          <img src={item.featured_image.url} alt={item.featured_image.alt} />
        </a>
      </div>
      <div className="mini-cart__item-content">
        <div className="mini-cart__item-content-top">
          <div className="mini-cart__item-content-left">
            <h5 className="mini-cart__item-title">
              <a href={product_url}>{item.product_title}</a>
            </h5>
            {item.options_with_values?.length
              ? item.options_with_values?.map((option) =>
                  option.name != "Width" ? (
                    <div
                      className={`mini-cart__item-option ${option?.name}`}
                      key={`item-${item.key}-option-${option?.name}-${option?.value}`}
                    >
                      {option?.name}: {option?.value}
                    </div>
                  ) : null
                )
              : null}
            {item.selling_plan_allocation?.selling_plan?.name ? (
              <div
                className="mini-cart__item-option option-delivery"
                key={`item-${item.key}-plan-${item.selling_plan_allocation?.selling_plan?.id}`}
              >
                {item.selling_plan_allocation?.selling_plan?.name}
              </div>
            ) : null}
          </div>
          <div className="mini-cart__item-content-right">
            <div className={`mini-cart__item-price ${discounted_class}`}>
              <span className="final-price">
                {formatMoney(item.line_price, miniCartData.moneyFormat)}
              </span>
              {discounted_price ? (
                <span className="original-price">
                  {formatMoney(comparePrice, miniCartData.moneyFormat)}
                </span>
              ) : null}
            </div>
            {discounted_price ? (
              <div className="mini-cart__discounted-price">
                <span className="save-price">
                  {formatMoney(diff_discounted, miniCartData.moneyFormat)} off
                </span>
              </div>
            ) : null}
          </div>
        </div>
        <div className={`mini-cart__item-content-bottom ${hide_qty_class}`}>
          {item.handle != "rise-ai-giftcard" && (
            <div className="mini-cart__item_qty">
              <button
                className="mini-cart__item-button"
                onClick={() => handleUpdateCount("minus")}
              >
                –
              </button>
              <div className="mini-cart__item-count">{item.quantity}</div>
              <button
                className="mini-cart__item-button"
                onClick={() => handleUpdateCount("plus")}
              >
                +
              </button>
            </div>
          )}

          <div className="mini-cart__item_remove">
            <button
              className="mini-cart__item-remove"
              onClick={handleRemoveItem}
            >
              {" "}
              Remove{" "}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MiniCartItem;
